<template>
	<div>
		<div class="form-group row">
		    <label for="productFilterEntityProperty" class="col-md-3 col-form-label text-right">Entity</label>
		    <div class="col-md-9">
				<div class="input-price-rule-entity-container">
				    <select2 v-model="selectedEntity" name="entity" title="Select fields..." tabindex="-1" aria-hidden="true" :config="{placeholder: '', width: '100%'}">
		                <option></option>
		                <option value="product">Product Entity</option>
				        <option value="product_attribute">Product Attribute Entity</option>
				        <option value="product_category" >Product Category Entity</option>
				        <option value="product_brand">Product Brand Entity</option>
						<option value="product_related_product">Related Product Entity</option>
		            </select2>
		            <transition name="nested-selector">
				        <div v-if="selectedEntity == 'product' || selectedEntity == 'product_attribute' || selectedEntity == 'product_related_product'" class="nested-entity-child">
		        		    <select2 name="entity_property"  tabindex="-1" aria-hidden="true" :config="{placeholder: '', width: '100%'}">
		                    </select2>
				        </div>
					</transition>	
				</div>
		    </div>
		</div>
		<div class="form-group row">
		    <label for="productFilterCriteriaType" class="col-md-3 col-form-label text-right">Filter Type</label>
		    <div class="col-md-9">
		        <select name="criteria_type" class="select_fullwide" id="productFilterCriteriaType">
		            <option></option>
		            <option value="equal">Equal</option>
		            <option value="not_equal">Not Equal</option>
		            <option v-if="uiStates.showCriteria == 'criteria_input'" value="greater_than">Greater than</option>
		            <option v-if="uiStates.showCriteria == 'criteria_input'" value="greater_than_or_equal">Greater than or equal</option>
		            <option v-if="uiStates.showCriteria == 'criteria_input'" value="less_than">Less than</option>
		            <option v-if="uiStates.showCriteria == 'criteria_input'" value="less_than_or_equal">Less than or equal</option>
		            <option v-if="uiStates.showCriteria == 'criteria_input'" value="like">Like</option>
		            <option v-if="uiStates.showCriteria == 'criteria_input'" value="not_like">Not like</option>
		            <option v-if="uiStates.showCriteria == 'criteria_input'" value="is_null">Is null</option>
		            <option v-if="uiStates.showCriteria == 'criteria_input'" value="is_not_null">Is not null</option>
		        </select>
		    </div>
		</div>
		<div class="form-group row">
		    <label for="productFilterCriteriaString" class="col-md-3 col-form-label text-right">Criteria</label>
		    <div class="col-md-9">
				<input v-if="uiStates.showCriteria == 'criteria_input'" type="text" name="criteria_string" class="form-control" id="productFilterCriteriaString">
		        <div v-else  class="criteria_select">
    			    <select2 name="criteria_string"  tabindex="-1" aria-hidden="true" :config="{placeholder: '', width: '100%'}">
    	            </select2>
					<input type="hidden" value="id" name="entity_property">
		        </div>
		    </div>
		</div>
	</div>
</template>

<style scoped="" lang="scss">
	.nested-entity-child{
		transition: all .5s;
		margin-top:10px;
	}
	.nested-selector-enter-active, .nested-selector-leave-active {
	  	transition: all .5s;
	  	height: 38px;
	}
	.nested-selector-enter, .nested-selector-leave-to{
		margin-top:0px;
	  	opacity: 0;
	  	height: 1px;
	  	.nested-entity-child{
			margin-top: 0px;
	  	}
	}
	select{
		background-color: white !important;
		border: solid 1px rgba(57, 81, 155, 0.3) !important;
	}
</style>

<script type="text/javascript">
	import Vue from 'vue';
	import VueEvents from 'vue-events'
	import select2 from 'select2';

	Vue.use(VueEvents)
	
	export default {
	    name: 'entity-selector',
	    props: [],
	    data() {
	    	return {
	    		selectedEntity: '',
	    		uiStates: {
					showCriteria: 'criteria_input',
	    		},
				entities: {
					product: dataObject.product_entity_names,
					attribute: dataObject.attribute_entity_names,
					category: dataObject.category_entity_names,
					brands: dataObject.brand_entity_names,
					relatedProducts: dataObject.related_type_names,
				}
			}
	    },
	    watch: {
	        selectedEntity: function () {
				if (this.selectedEntity == 'product' || this.selectedEntity == 'product_attribute' || this.selectedEntity == 'product_related_product') {
					this.uiStates.showCriteria = 'criteria_input';
					if( $('.nested-entity-child select').has('option').length > 0 ) {
						$('.nested-entity-child select').empty().select2('destroy');
		        	}
    	        	this.$nextTick(() => {
						if (this.selectedEntity == 'product') {
    						$('.nested-entity-child select').select2({ data : this.entities.product, width: "100%", placeholder: 'Select Product Entity Property...' });
						} else if (this.selectedEntity == 'product_related_product') {
	    					$('.nested-entity-child select').select2({ data : this.entities.relatedProducts, width: "100%", placeholder: 'Select Product Relation Type...' });
						}else{
							$('.nested-entity-child select').select2({ data : this.entities.attribute, width: "100%", placeholder: 'Select Attribute Property...' });
						}
    				})
				}

				if (this.selectedEntity == 'product_category' || this.selectedEntity == 'product_brand') {
					this.uiStates.showCriteria = 'criteria_select';
					if( $('.criteria_select select').has('option').length > 0 ) {
						$('.criteria_select select').empty().select2('destroy');
		        	}
    	        	this.$nextTick(() => {
	    	        	if (this.selectedEntity == 'product_category') {
	    					$('.criteria_select select').select2({ data : this.entities.category, width: "100%", placeholder: 'Select Category Criteria...' });
						} else{
							$('.criteria_select select').select2({ data : this.entities.brands, width: "100%", placeholder: 'Select Brand Criteria...' });
	    				}
    				})
				}
	        },
	    }
	};
</script>
